export default __webpack_public_path__ + "static/media/error-toast.8aaea1a2.svg";